import Bar from "./Bar";

// Mirrors the Leaderboard body: a 2-1-3 podium, then ranked rows, then the
// caller's own row pinned at the bottom with the highlight treatment.
// Sizes track Podium.js (96px winner / 68px runners-up) and LeaderboardRow.js
// (w-6 rank slot, 32px avatar, name·office, count right).

const Pillar = ({ size }) => (
  <div className="mx-2 flex flex-col items-center">
    <Bar w={size} h={size} r={size / 2} />
    <div className="mt-1">
      <Bar w={size === 96 ? 84 : 66} h={13} />
    </div>
    <div className="mt-1">
      <Bar w={26} h={15} />
    </div>
  </div>
);

const Row = ({ pinned = false }) => (
  <div
    className="flex items-center gap-3 border-b border-light_gray px-6 py-3"
    style={
      pinned
        ? { backgroundColor: "#f7f9ec", borderTop: "1px solid #b4c540" }
        : undefined
    }
  >
    <div className="flex w-6 justify-center">
      <Bar w={10} h={12} />
    </div>
    <Bar w={32} h={32} r={16} className="shrink-0" />
    <div className="flex-1">
      <Bar w="44%" h={13} />
    </div>
    <Bar w={22} h={14} />
  </div>
);

const LeaderboardSkeleton = ({ rows = 5 }) => (
  <>
    <div className="flex items-end justify-center px-6 py-6">
      <Pillar size={68} />
      <Pillar size={96} />
      <Pillar size={68} />
    </div>

    <div>
      {Array.from({ length: rows }, (_, i) => (
        <Row key={i} />
      ))}
    </div>

    <Row pinned />
  </>
);

export default LeaderboardSkeleton;
